var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarqueeSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.393,
    height: 107.04,
    viewBox: "0 0 165.393 107.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Marquee_Sign",
    "data-name": "Marquee Sign",
    transform: "translate(54.509 31.093)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(-54.509 -31.093)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37457",
    "data-name": "Path 37457",
    d: "M20.82,38.517V96.005l56.94,19.631h42.55l55.743-17.841V37.888L122.478,19.5h-46.3Z",
    transform: "translate(-16.393 -15.355)",
    fill: "#edf0f4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1869",
    "data-name": "Rectangle 1869",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 28.684)",
    fill: "#07131e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1870",
    "data-name": "Rectangle 1870",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 44.939)",
    fill: "#07131e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1871",
    "data-name": "Rectangle 1871",
    width: 100.863,
    height: 0.189,
    transform: "translate(32.265 12.443)",
    fill: "#07131e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1872",
    "data-name": "Rectangle 1872",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 28.701)",
    fill: "#07131e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1873",
    "data-name": "Rectangle 1873",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 77.47)",
    fill: "#07131e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1874",
    "data-name": "Rectangle 1874",
    width: 100.863,
    height: 0.189,
    transform: "translate(32.265 93.711)",
    fill: "#07131e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 61.197)",
    fill: "#07131e"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1876",
    "data-name": "Rectangle 1876",
    width: 157.489,
    height: 0.189,
    transform: "translate(3.953 77.455)",
    fill: "#07131e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37458",
    "data-name": "Path 37458",
    d: "M164.076,39.039a22.425,22.425,0,0,0-16.309-14.358l-47.775-10.5a80.636,80.636,0,0,0-34.612,0l-47.775,10.5A22.423,22.423,0,0,0-.01,46.589V82.437a22.424,22.424,0,0,0,17.616,21.907l47.775,10.5a80.636,80.636,0,0,0,34.612,0l47.775-10.5h0a22.423,22.423,0,0,0,17.616-21.907V46.589a22.36,22.36,0,0,0-1.307-7.55Zm-5.883,43.4a15.239,15.239,0,0,1-11.967,14.885h0l-47.775,10.5a73.462,73.462,0,0,1-31.525,0l-47.775-10.5A15.239,15.239,0,0,1,7.185,82.437V46.589A15.239,15.239,0,0,1,19.151,31.7L66.926,21.2a73.462,73.462,0,0,1,31.525,0l47.775,10.5a15.239,15.239,0,0,1,11.967,14.885Z",
    transform: "translate(0.01 -9.686)",
    fill: "#596268"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37459",
    "data-name": "Path 37459",
    d: "M164.076,26.739a22.425,22.425,0,0,0-16.309-14.358L99.992,1.879a80.636,80.636,0,0,0-34.612,0l-47.775,10.5A22.423,22.423,0,0,0-.01,34.288V70.137A22.424,22.424,0,0,0,17.606,92.045l47.775,10.5a80.636,80.636,0,0,0,34.612,0l47.775-10.5h0a22.423,22.423,0,0,0,17.616-21.907V34.288A22.36,22.36,0,0,0,164.076,26.739Zm-5.883,43.4a15.239,15.239,0,0,1-11.967,14.885h0l-47.775,10.5a73.462,73.462,0,0,1-31.525,0l-47.775-10.5A15.239,15.239,0,0,1,7.185,70.137V34.288A15.239,15.239,0,0,1,19.151,19.4L66.926,8.9a73.462,73.462,0,0,1,31.525,0l47.775,10.5a15.239,15.239,0,0,1,11.967,14.885Z",
    transform: "translate(0.01 0)",
    fill: "#eae553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19425",
    "data-name": "Group 19425",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37460",
    "data-name": "Path 37460",
    d: "M37.193,339.913a15.294,15.294,0,0,0,8.6,5.335l47.775,10.5a73.464,73.464,0,0,0,31.525,0l47.775-10.5h0a15.239,15.239,0,0,0,11.967-14.885v-.393a15.239,15.239,0,0,1-11.967,14.885h0l-47.775,10.5a73.462,73.462,0,0,1-31.525,0L45.8,344.855A15.239,15.239,0,0,1,33.83,329.97v.393a15.3,15.3,0,0,0,3.363,9.55Z",
    transform: "translate(-26.637 -259.835)",
    fill: "#fffffa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37461",
    "data-name": "Path 37461",
    d: "M164.076,26.739a22.425,22.425,0,0,0-16.309-14.358L99.992,1.879a80.636,80.636,0,0,0-34.612,0l-47.775,10.5A22.423,22.423,0,0,0-.01,34.288v.393A22.424,22.424,0,0,1,17.606,12.774l47.775-10.5a80.636,80.636,0,0,1,34.612,0l47.775,10.5a22.423,22.423,0,0,1,17.616,21.907v-.393a22.361,22.361,0,0,0-1.307-7.55Z",
    transform: "translate(0.01 0)",
    fill: "#fffffa"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.332 63.383) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.332 63.383) rotate(-80.78)",
    fill: "#596268"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.154 58.007)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.33 49.716) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.33 49.716) rotate(-80.78)",
    fill: "#596268"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.154 44.34)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.332 37.238) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.332 37.238) rotate(-80.78)",
    fill: "#596268"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.154 31.863)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(4.949 26.215) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(4.949 26.215) rotate(-80.78)",
    fill: "#596268"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(4.77 20.84)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(14.372 19.304) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(14.372 19.304) rotate(-80.78)",
    fill: "#596268"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(14.194 13.928)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(27.408 16.409) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(27.408 16.409) rotate(-80.78)",
    fill: "#596268"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(27.228 11.033)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(40.641 13.416) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(40.641 13.416) rotate(-80.78)",
    fill: "#596268"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(40.461 8.041)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(53.589 10.689) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(53.589 10.689) rotate(-80.78)",
    fill: "#596268"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(53.409 5.314)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(66.612 7.794) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(66.612 7.794) rotate(-80.78)",
    fill: "#596268"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(66.432 2.417)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(80.047 6.621) rotate(-80.78)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(80.047 6.621) rotate(-80.78)",
    fill: "#596268"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(79.863 1.248)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(156.209 21.788)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(156.209 21.788)",
    fill: "#596268"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(155.673 20.84)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 32.811)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 32.811)",
    fill: "#596268"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.227 31.863)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 45.481)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 45.481)",
    fill: "#596268"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.227 44.533)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 58.955)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 58.955)",
    fill: "#596268"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.227 58.007)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 71.582)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.763 71.582)",
    fill: "#596268"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(159.227 70.634)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(154.162 82.248)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(154.162 82.248)",
    fill: "#596268"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(153.627 81.3)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(142.525 87.813)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(142.525 87.813)",
    fill: "#596268"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(141.989 86.865)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(130.161 90.393)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(130.161 90.393)",
    fill: "#596268"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(129.625 89.445)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(117.682 93.133)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(117.682 93.133)",
    fill: "#596268"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(117.147 92.185)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(105.182 95.76)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(105.182 95.76)",
    fill: "#596268"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(104.647 94.812)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(92.818 98.332)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(92.818 98.332)",
    fill: "#596268"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(92.283 97.384)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(67.997 98.468)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(67.997 98.468)",
    fill: "#596268"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(67.461 97.52)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(55.497 95.76)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(55.497 95.76)",
    fill: "#596268"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(54.961 94.812)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(43.152 93.031)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(43.152 93.031)",
    fill: "#596268"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(42.616 92.083)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(30.652 90.293)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(30.652 90.293)",
    fill: "#596268"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(30.116 89.345)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(18.309 87.551)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(18.309 87.551)",
    fill: "#596268"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(17.773 86.603)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(7.331 82.248)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(7.331 82.248)",
    fill: "#596268"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(6.795 81.3)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.798 71.582)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.798 71.582)",
    fill: "#596268"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(1.263 70.634)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(93.59 3.365)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(93.59 3.365)",
    fill: "#596268"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(92.557 6.642) rotate(-76.72)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(106.689 6.092)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(106.689 6.092)",
    fill: "#596268"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(105.655 9.368) rotate(-76.72)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(119.865 8.987)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(119.865 8.987)",
    fill: "#596268"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(118.834 12.262) rotate(-76.72)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(132.884 11.845)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(132.884 11.845)",
    fill: "#596268"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(131.851 15.12) rotate(-76.72)",
    fill: "#edf0f4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(146.245 14.864)",
    fill: "#a0afba",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(146.245 14.864)",
    fill: "#596268"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 2.423,
    cy: 2.423,
    r: 2.423,
    transform: "translate(145.212 18.137) rotate(-76.72)",
    fill: "#edf0f4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37462",
    "data-name": "Path 37462",
    d: "M309.33,157.168v-12.7h8.406v2.213h-5.722v3.025h5.165v2.213h-5.165v5.246H309.33Z",
    transform: "translate(-243.58 -113.763)",
    fill: "#07131e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37463",
    "data-name": "Path 37463",
    d: "M357.016,157.168H354.14l4.383-12.7h3.46l4.376,12.7h-2.876l-3.18-9.8h-.1l-3.186,9.8Zm-.181-4.991h6.8v2.1h-6.8Z",
    transform: "translate(-278.866 -113.763)",
    fill: "#07131e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37464",
    "data-name": "Path 37464",
    d: "M429.421,144.48v12.7H427.1l-5.524-7.992h-.094v7.992H418.8v-12.7h2.355l5.482,7.985h.113V144.48Z",
    transform: "translate(-329.782 -113.771)",
    fill: "#07131e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37465",
    "data-name": "Path 37465",
    d: "M158.72,234.168v-12.7h8.406v2.213H161.4v3.025h5.165v2.213H161.4v5.246H158.72Z",
    transform: "translate(-124.982 -174.397)",
    fill: "#07131e"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37466",
    "data-name": "Path 37466",
    d: "M206.406,234.168H203.53l4.383-12.7h3.46l4.376,12.7h-2.876l-3.18-9.8h-.1l-3.186,9.8Zm-.181-4.991h6.8v2.1h-6.8Z",
    transform: "translate(-160.268 -174.397)",
    fill: "#07131e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37467",
    "data-name": "Path 37467",
    d: "M267.932,221.48,271,231.128h.117l3.076-9.648h2.976l-4.376,12.7h-3.46l-4.383-12.7Z",
    transform: "translate(-208.633 -174.405)",
    fill: "#07131e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37468",
    "data-name": "Path 37468",
    d: "M340.46,227.173a7.373,7.373,0,0,1-.784,3.535,5.463,5.463,0,0,1-2.132,2.223,6.378,6.378,0,0,1-6.066,0,5.467,5.467,0,0,1-2.125-2.225,8.364,8.364,0,0,1,0-7.063,5.475,5.475,0,0,1,2.125-2.223,6.394,6.394,0,0,1,6.066,0,5.462,5.462,0,0,1,2.132,2.223A7.367,7.367,0,0,1,340.46,227.173Zm-2.721,0a5.734,5.734,0,0,0-.4-2.27,3.089,3.089,0,0,0-1.124-1.4,3.255,3.255,0,0,0-3.4,0,3.086,3.086,0,0,0-1.124,1.4,6.648,6.648,0,0,0,0,4.54,3.089,3.089,0,0,0,1.124,1.4,3.254,3.254,0,0,0,3.4,0,3.089,3.089,0,0,0,1.124-1.4A5.734,5.734,0,0,0,337.739,227.173Z",
    transform: "translate(-258.731 -173.751)",
    fill: "#07131e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37469",
    "data-name": "Path 37469",
    d: "M393.85,234.168v-12.7h5.01a5.423,5.423,0,0,1,2.459.512,3.6,3.6,0,0,1,1.556,1.445,4.325,4.325,0,0,1,.536,2.191,4.147,4.147,0,0,1-.546,2.172,3.556,3.556,0,0,1-1.577,1.392,5.839,5.839,0,0,1-2.5.483h-3.354v-2.157h2.921a3.365,3.365,0,0,0,1.277-.21,1.514,1.514,0,0,0,.759-.633,2.008,2.008,0,0,0,.251-1.048,2.1,2.1,0,0,0-.251-1.067,1.594,1.594,0,0,0-.763-.661,3.181,3.181,0,0,0-1.286-.227h-1.811v10.5H393.85Zm6.857-5.777,3.156,5.779H400.9l-3.088-5.779Z",
    transform: "translate(-310.135 -174.397)",
    fill: "#07131e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37470",
    "data-name": "Path 37470",
    d: "M450.435,221.48v12.7H447.75v-12.7Z",
    transform: "translate(-352.579 -174.405)",
    fill: "#07131e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37471",
    "data-name": "Path 37471",
    d: "M468.52,223.693V221.48h10.428v2.213H475.06v10.483h-2.653V223.693Z",
    transform: "translate(-368.934 -174.405)",
    fill: "#07131e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37472",
    "data-name": "Path 37472",
    d: "M525.69,234.168v-12.7h8.555v2.213h-5.871v3.025h5.431v2.213h-5.431v3.031h5.9v2.213H525.69Z",
    transform: "translate(-413.953 -174.397)",
    fill: "#07131e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37473",
    "data-name": "Path 37473",
    d: "M581.4,224.494a1.571,1.571,0,0,0-.638-1.165,2.533,2.533,0,0,0-1.53-.414,2.985,2.985,0,0,0-1.109.183,1.557,1.557,0,0,0-.691.506,1.2,1.2,0,0,0-.238.731,1.023,1.023,0,0,0,.147.6,1.432,1.432,0,0,0,.438.438,3.243,3.243,0,0,0,.644.317,6.5,6.5,0,0,0,.782.227l1.141.272a8.029,8.029,0,0,1,1.526.5,4.633,4.633,0,0,1,1.2.763,3.23,3.23,0,0,1,.791,1.067,3.414,3.414,0,0,1,.289,1.407,3.5,3.5,0,0,1-.593,2.017,3.767,3.767,0,0,1-1.686,1.32,6.75,6.75,0,0,1-2.65.468,6.929,6.929,0,0,1-2.676-.472,3.887,3.887,0,0,1-1.773-1.4,4.153,4.153,0,0,1-.667-2.3h2.6a1.91,1.91,0,0,0,.37,1.063,1.976,1.976,0,0,0,.874.638,3.4,3.4,0,0,0,1.243.215,3.228,3.228,0,0,0,1.188-.2,1.824,1.824,0,0,0,.784-.553,1.267,1.267,0,0,0,.278-.812,1.058,1.058,0,0,0-.251-.718,1.963,1.963,0,0,0-.731-.5,7.5,7.5,0,0,0-1.175-.372l-1.382-.346a5.776,5.776,0,0,1-2.536-1.222,2.834,2.834,0,0,1-.925-2.238,3.318,3.318,0,0,1,.616-2.015,4.116,4.116,0,0,1,1.715-1.345,6.049,6.049,0,0,1,2.481-.482,5.954,5.954,0,0,1,2.47.482,3.9,3.9,0,0,1,1.645,1.345,3.571,3.571,0,0,1,.608,2h-2.574Z",
    transform: "translate(-452.081 -173.767)",
    fill: "#07131e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37474",
    "data-name": "Path 37474",
    d: "M185.18,311.168v-12.7h5.01a5.423,5.423,0,0,1,2.459.512,3.6,3.6,0,0,1,1.556,1.445,4.326,4.326,0,0,1,.536,2.191,4.147,4.147,0,0,1-.546,2.172,3.556,3.556,0,0,1-1.577,1.392,5.839,5.839,0,0,1-2.5.482h-3.354v-2.157h2.92a3.365,3.365,0,0,0,1.277-.21,1.514,1.514,0,0,0,.759-.633,2.008,2.008,0,0,0,.251-1.048,2.1,2.1,0,0,0-.251-1.067,1.594,1.594,0,0,0-.763-.661,3.181,3.181,0,0,0-1.286-.227h-1.811v10.5H185.18Zm6.857-5.777,3.156,5.779H192.23l-3.088-5.779Z",
    transform: "translate(-145.818 -235.03)",
    fill: "#07131e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37475",
    "data-name": "Path 37475",
    d: "M239.08,311.168v-12.7h8.555v2.213h-5.871v3.025H247.2v2.213h-5.431v3.031h5.9v2.213H239.08Z",
    transform: "translate(-188.262 -235.03)",
    fill: "#07131e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37476",
    "data-name": "Path 37476",
    d: "M289.383,311.168l-3.633-12.7h2.933l2.1,8.823h.106l2.319-8.823h2.51l2.313,8.84h.113l2.1-8.84h2.933l-3.632,12.7h-2.617l-2.419-8.3h-.1l-2.412,8.3h-2.616Z",
    transform: "translate(-225.012 -235.03)",
    fill: "#07131e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37477",
    "data-name": "Path 37477",
    d: "M374.126,311.168H371.25l4.383-12.7h3.46l4.376,12.7h-2.876l-3.18-9.8h-.1l-3.186,9.8Zm-.181-4.991h6.8v2.1h-6.8Z",
    transform: "translate(-292.339 -235.03)",
    fill: "#07131e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37478",
    "data-name": "Path 37478",
    d: "M435.91,311.168v-12.7h5.01a5.423,5.423,0,0,1,2.459.512,3.6,3.6,0,0,1,1.556,1.445,4.326,4.326,0,0,1,.536,2.191,4.147,4.147,0,0,1-.546,2.172,3.556,3.556,0,0,1-1.577,1.392,5.839,5.839,0,0,1-2.5.482H437.5v-2.157h2.92a3.365,3.365,0,0,0,1.277-.21,1.513,1.513,0,0,0,.759-.633,2.008,2.008,0,0,0,.251-1.048,2.1,2.1,0,0,0-.251-1.067,1.594,1.594,0,0,0-.763-.661,3.181,3.181,0,0,0-1.286-.227h-1.811v10.5H435.91Zm6.857-5.777,3.156,5.779H442.96l-3.088-5.779Z",
    transform: "translate(-343.255 -235.03)",
    fill: "#07131e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37479",
    "data-name": "Path 37479",
    d: "M494.312,311.168h-4.5v-12.7h4.538a6.761,6.761,0,0,1,3.3.759,5.174,5.174,0,0,1,2.13,2.179,8.134,8.134,0,0,1,0,6.806,5.2,5.2,0,0,1-2.138,2.189,6.832,6.832,0,0,1-3.326.763Zm-1.817-2.3h1.7a4.317,4.317,0,0,0,2.006-.425,2.718,2.718,0,0,0,1.229-1.32,6.662,6.662,0,0,0,0-4.615,2.7,2.7,0,0,0-1.224-1.314,4.319,4.319,0,0,0-2-.421H492.5v8.1Z",
    transform: "translate(-385.699 -235.03)",
    fill: "#07131e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37480",
    "data-name": "Path 37480",
    d: "M554.951,301.494a1.571,1.571,0,0,0-.638-1.165,2.533,2.533,0,0,0-1.53-.414,2.985,2.985,0,0,0-1.11.183,1.558,1.558,0,0,0-.691.506,1.2,1.2,0,0,0-.238.731,1.023,1.023,0,0,0,.147.6,1.433,1.433,0,0,0,.438.438,3.24,3.24,0,0,0,.644.317,6.51,6.51,0,0,0,.782.227l1.141.272a8.029,8.029,0,0,1,1.526.5,4.633,4.633,0,0,1,1.2.763,3.229,3.229,0,0,1,.791,1.067,3.414,3.414,0,0,1,.289,1.407,3.5,3.5,0,0,1-.593,2.017,3.768,3.768,0,0,1-1.686,1.32,6.749,6.749,0,0,1-2.65.468,6.929,6.929,0,0,1-2.676-.472,3.886,3.886,0,0,1-1.773-1.4,4.153,4.153,0,0,1-.667-2.3h2.6a1.91,1.91,0,0,0,.37,1.063,1.976,1.976,0,0,0,.874.638,3.4,3.4,0,0,0,1.243.215,3.228,3.228,0,0,0,1.188-.2,1.824,1.824,0,0,0,.784-.553,1.267,1.267,0,0,0,.278-.812,1.058,1.058,0,0,0-.251-.718,1.963,1.963,0,0,0-.731-.5,7.505,7.505,0,0,0-1.175-.372l-1.382-.346a5.777,5.777,0,0,1-2.536-1.222,2.834,2.834,0,0,1-.925-2.238,3.318,3.318,0,0,1,.616-2.015,4.116,4.116,0,0,1,1.715-1.345,6.048,6.048,0,0,1,2.48-.483,5.954,5.954,0,0,1,2.47.483,3.9,3.9,0,0,1,1.645,1.345,3.571,3.571,0,0,1,.608,2h-2.574Z",
    transform: "translate(-431.253 -234.4)",
    fill: "#07131e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarqueeSign);
export default __webpack_public_path__ + "static/media/marquee_sign.5604526c67a558a16c111dafb61b6bea.svg";
export { ForwardRef as ReactComponent };